import { IRouteConfig } from '@/router/types';

export default [
  {
    path: '/inspiration-center',
    name: 'InspirationCenter',
    component: () => import('@/layouts/main/index.vue'),
    redirect: '/inspiration-center/training-task/list',
    meta: {
      title: '灵感中心',
    },
    children: [
      {
        path: 'training-task/list',
        name: 'InspirationCenterTrainingTaskList',
        component: () => import('./training-task/views/list/index.vue'),
        meta: {
          title: '跑图任务',
          auth: true,
          isKeepAlive: false,
        },
      },
      {
        path: 'style-innovation/aigc-webview/:taskCode?',
        name: 'InspirationCenterStyleInnovationAigcWebview',
        component: () => import('./style-innovation/views/aigc-webview/index.vue'),
        meta: {
          title: '款式创新',
          auth: true,
          isKeepAlive: false,
        },
      },
      {
        path: 'smart-planning/list',
        name: 'InspirationCenterSmartPlanningList',
        component: () => import('./smart-planning/views/list/index.vue'),
        meta: {
          title: '智能开款',
          auth: true,
          isKeepAlive: false,
        },
      },
      {
        path: 'smart-planning/detail/:id',
        name: 'InspirationCenterSmartPlanningDetail',
        component: () => import('./smart-planning/views/detail/index.vue'),
        meta: {
          title: '智能开款详情',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterSmartPlanningList'
        },
      },
      {
        path: 'smart-planning/create/:id?',
        name: 'InspirationCenterSmartPlanningCreate',
        component: () => import('./smart-planning/views/create/index.vue'),
        meta: {
          title: '新增智能开款',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterSmartPlanningList'
        },
      },
      {
        path: 'smart-planning/edit/:id',
        name: 'InspirationCenterSmartPlanningEdit',
        component: () => import('./smart-planning/views/edit/index.vue'),
        meta: {
          title: '编辑智能开款',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterSmartPlanningList'
        },
      },
      {
        path: 'smart-planning/batch-detail/:id',
        name: 'InspirationCenterSmartPlanningBatchDetail',
        component: () => import('./smart-planning/views/batch-detail/index.vue'),
        meta: {
          title: '批量智能开款详情',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterSmartPlanningList'
        },
      },
      {
        path: 'smart-planning/batch-edit/:id',
        name: 'InspirationCenterSmartPlanningBatchEdit',
        component: () => import('./smart-planning/views/batch-edit/index.vue'),
        meta: {
          title: '批量智能开款编辑',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterSmartPlanningList'
        },
      },
      {
        path: 'style-derivation/list',
        name: 'InspirationCenterStyleDerivationList',
        component: () => import('./style-derivation/views/list/index.vue'),
        meta: {
          title: '款式衍生',
          auth: true,
          isKeepAlive: false,
        },
      },
      {
        path: 'pattern-manager/create',
        name: 'InspirationCenterPatternManagerCreate',
        component: () => import('./pattern-manager/views/create-or-edit/index.vue'),
        meta: {
          title: '服装换色',
          auth: true,
          isKeepAlive: false,
        },
      },
      {
        path: 'pattern-manager/edit/:detailId/:taskDetailId',
        name: 'InspirationCenterPatternManagerEdit',
        component: () => import('./pattern-manager/views/create-or-edit/index.vue'),
        meta: {
          title: '服装换色',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterPatternManagerCreate'
        },
      },
      {
        path: 'pattern-manager/history',
        name: 'InspirationCenterPatternManagerHistory',
        component: () => import('./pattern-manager/views/history/index.vue'),
        meta: {
          title: '生成记录',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterPatternManagerCreate'
        },
      },
      {
        path: 'virtual-change/list',
        name: 'InspirationCenterVirtualChangeList',
        component: () => import('./virtual-change/views/list/index.vue'),
        meta: {
          title: '虚拟换衣',
          auth: true,
          isKeepAlive: false,
        },
      },
      {
        path: 'virtual-change/create',
        name: 'InspirationCenterVirtualChangeCreate',
        component: () => import('./virtual-change/views/create/index.vue'),
        meta: {
          title: '虚拟换衣',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterVirtualChangeList'
        },
      },
      {
        path: 'virtual-change/detail/:taskId',
        name: 'InspirationCenterVirtualChangeDetail',
        component: () => import('./virtual-change/views/detail/index.vue'),
        meta: {
          title: '虚拟换衣详情',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterVirtualChangeList'
        },
      },
      {
        path: 'virtual-change/batch-create',
        name: 'InspirationCenterVirtualChangeBatchCreate',
        component: () => import('./virtual-change/views/batch-create/index.vue'),
        meta: {
          title: '虚拟换衣',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterVirtualChangeList'
        },
      },
      {
        path: 'virtual-change/submit/:styleCode',
        name: 'InspirationCenterVirtualChangeResultSubmit',
        component: () => import('./virtual-change/views/result/submit.vue'),
        meta: {
          title: '虚拟换衣提交结果',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterVirtualChangeList'
        },
      },
      {
        path: 'virtual-change/check/:styleCode',
        name: 'InspirationCenterVirtualChangeResultCheck',
        component: () => import('./virtual-change/views/result/check.vue'),
        meta: {
          title: '虚拟换衣结果验收',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterVirtualChangeList'
        },
      },
      {
        path: 'logo-manager/list',
        name: 'InspirationCenterLogoManagerList',
        component: () => import('./pattern-manager/views/list/index.vue'),
        meta: {
          title: '款式贴图任务',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterLogoManagerList'
        },
      },
      {
        path: 'logo-manager/detail/:id',
        name: 'InspirationCenterLogoManagerDetail',
        component: () => import('./pattern-manager/views/detail/index.vue'),
        meta: {
          title: '款式贴图详情',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterLogoManagerList'
        },
      },
      {
        path: 'pattern-library/list',
        name: 'InspirationCenterPatternLibraryList',
        component: () => import('./pattern-library/views/list/index.vue'),
        meta: {
          title: '图案库',
          auth: true,
        },
      },
      {
        path: 'pattern-library/task-list',
        name: 'InspirationCenterPatternLibraryTaskList',
        component: () => import('./pattern-library/views/task-list/index.vue'),
        meta: {
          title: '图案设计任务',
          auth: true,
        },
      },
      {
        path: 'pattern-library/expand-list',
        name: 'InspirationCenterPatternLibraryExpandList',
        component: () => import('./pattern-library/views/expand-list/index.vue'),
        meta: {
          title: '扩图任务列表',
          auth: true,
        },
      },
      {
        path: 'pattern-library/prompt-list',
        name: 'InspirationCenterPatternLibraryPromptList',
        component: () => import('./pattern-library/views/prompt-list/index.vue'),
        meta: {
          title: '提示词任务列表',
          auth: true,
        },
      },
      {
        path: 'pattern-library/task-detail/:id',
        name: 'InspirationCenterPatternLibraryTaskDetail',
        component: () => import('./pattern-library/views/task-detail/index.vue'),
        meta: {
          title: '图案设计任务详情',
          auth: true,
          activeMenu: 'InspirationCenterPatternLibraryTaskList'
        },
      },
      {
        path: 'pattern-library/create-task',
        name: 'InspirationCenterPatternLibraryCreateTask',
        component: () => import('./pattern-library/views/create-task/index.vue'),
        meta: {
          title: '图案设计',
          auth: true,
        },
      },
      {
        path: 'pattern-library/task-rule-manage',
        name: 'InspirationCenterPatternLibraryTaskRuleManage',
        component: () => import('./pattern-library/views/task-rule-manage/index.vue'),
        meta: {
          title: '规则资料维护',
          auth: true,
        },
      },
      {
        path: 'select-style/list',
        name: 'InspirationCenterSelectStyleList',
        component: () => import('./select-style/views/list/index.vue'),
        meta: {
          title: '选款列表',
          auth: true,
        },
      },
      {
        path: 'select-style/detail/:id',
        name: 'InspirationCenterSelectStyleDetail',
        component: () => import('./select-style/views/detail/index.vue'),
        meta: {
          title: '选款详情',
          auth: false,
          activeMenu: 'InspirationCenterSelectStyleList'
        }
      },
      {
        path: 'image-manager/list',
        name: 'InspirationCenterImageManageList',
        component: () => import('./image-manager/views/list.vue'),
        meta: {
          title: '图片列表',
          auth: true,
          isKeepAlive: false,
        },
      },
      {
        path: 'ai-design-task/list',
        name: 'InspirationCenterAIDesignTaskList',
        component: () => import('./ai-design-task/views/list.vue'),
        meta: {
          title: 'ai设计任务',
          auth: true,
          isKeepAlive: false,
        },
      },
      {
        path: 'ai-design-task/create',
        name: 'InspirationCenterAIDesignTaskCreate',
        component: () => import('./ai-design-task/views/create-edit.vue'),
        meta: {
          title: '创建ai设计任务',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterAIDesignTaskList'
        },
      },
      {
        path: 'ai-design-task/detail/:taskCode',
        name: 'InspirationCenterAIDesignTaskDetail',
        component: () => import('./ai-design-task/views/detail/index.vue'),
        meta: {
          title: 'ai设计任务详情',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterAIDesignTaskList'
        },
      },
      {
        path: 'flower-pattern-extraction/list',
        name: 'InspirationCenterFlowerPatternExtractionList',
        component: () => import('./flower-pattern-extraction/views/list/index.vue'),
        meta: {
          title: '花型提取',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterFlowerPatternExtractionList'
        },
      },
      // 局部改款
      {
        path: 'pattern-modify/list',
        name: 'InspirationCenterPartialModifyList',
        component: () => import('./pattern-modify/views/list/index.vue'),
        meta: {
          title: '局部改款',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterPartialModifyList'
        },
      },
      {
        path: 'pattern-modify/create',
        name: 'InspirationCenterPartialModifyCreate',
        component: () => import('./pattern-modify/views/create/index.vue'),
        meta: {
          title: '局部改款工作台',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterPartialModifyList'
        },
      },
      {
        path: 'trend-center/list',
        name: 'InspirationCenterTrendCenterList',
        component: () => import('./trend/views/list/index.vue'),
        meta: {
          title: '趋势列表',
          auth: true,
          isKeepAlive: true,
        },
      },
      {
        path: 'trend-center/trend-social/:id',
        name: 'InspirationCenterTrendCenterSocialDetail',
        component: () => import('./trend/views/detail/index.vue'),
        meta: {
          title: '趋势热点详情',
          auth: true,
          isKeepAlive: false,
        },
      },
      {
        path: 'trend-center/trend-product/:id',
        name: 'InspirationCenterTrendCenterProductDetail',
        component: () => import('./trend/views/detail/index.vue'),
        meta: {
          title: '趋势热点详情',
          auth: true,
          isKeepAlive: false,
        },
      },
      {
        path: 'photography-task/list',
        name: 'InspirationCenterPhotographyTaskList',
        component: () => import('./photography-task/views/list/index.vue'),
        meta: {
          title: '摄影任务2.0',
          auth: true,
          activeMenu: 'InspirationCenterPhotographyTaskList',
          isKeepAlive: false,
        },
      },
      {
        path: 'photography-task/detail/:taskId',
        name: 'InspirationCenterPhotographyTaskDetail',
        component: () => import('./photography-task/views/detail/index.vue'),
        meta: {
          title: '摄影任务2.0详情',
          auth: true,
          activeMenu: 'InspirationCenterPhotographyTaskList',
          isKeepAlive: false,
        },
      },
      {
        path: 'photography-task/batchCreate',
        name: 'InspirationCenterPhotographyTaskBatchCreate',
        component: () => import('./photography-task/views/batch-create/index.vue'),
        meta: {
          title: '摄影任务2.0批量创建',
          auth: true,
          activeMenu: 'InspirationCenterPhotographyTaskList',
          isKeepAlive: false,
        },
      },
      {
        path: 'ai-studio/list',
        name: 'InspirationCenterAiStudioList',
        component: () => import('./ai-studio/views/list/index.vue'),
        meta: {
          title: 'AiStudio',
          auth: true,
          isKeepAlive: false,
        },
      },
      {
        path: 'ai-studio/detail/:id',
        name: 'InspirationCenterAiStudioDetail',
        component: () => import('./ai-studio/views/detail/index.vue'),
        meta: {
          title: 'AiStudio详情',
          auth: true,
          activeMenu: 'InspirationCenterAiStudioList',
          isKeepAlive: false,
        },
      },
      {
        path: 'ai-studio/batch-create',
        name: 'InspirationCenterAiStudioBatchCreate',
        component: () => import('./ai-studio/views/batch-create/index.vue'),
        meta: {
          title: 'AiStudio批量创建',
          auth: true,
          activeMenu: 'InspirationCenterAiStudioList',
          isKeepAlive: false,
        },
      },
      {
        path: 'ai-studio-task/list',
        name: 'InspirationCenterAiStudioTaskList',
        component: () => import('./ai-studio-task/views/list/index.vue'),
        meta: {
          title: '任务中心',
          auth: true,
          isKeepAlive: false,
        },
      },
      {
        path: 'ai-studio-task/detail/:id',
        name: 'InspirationCenterAiStudioTaskDetail',
        component: () => import('./ai-studio-task/views/detail/index.vue'),
        meta: {
          title: '任务中心详情',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterAiStudioTaskList',
        },
      },
    ],
  },
] as IRouteConfig[];
